// Os estados da aplicação (variáveis globais)
export default {
    user: {},
    token: ''
}
